export const CalendarDisplayType = Object.freeze({
  MONTH: 'MONTH',
  PARTIAL_WEEK: 'PARTIAL_WEEK',
});
